import React from 'react';
import { Link } from '@tanstack/react-router';
import {
  ArrowRight,
  Wrench,
  SlidersHorizontal,
  MessageSquare,
} from 'lucide-react';

import { useTranslation } from 'react-i18next';
import type { TFunction } from 'i18next';

const LIST_ITEM_CLASS =
  'group flex w-full items-center gap-3 rounded-lg pl-0 pr-3 py-2.5 text-left text-sm transition-all hover:bg-gray-50 dark:hover:bg-gray-800 hover:shadow-sm';
const ICON_WRAPPER_CLASS =
  'flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400 group-hover:bg-orange-100 group-hover:text-orange-700';

const settingsLinks = (t: TFunction<'pleri/chat'>) => [
  {
    to: '/settings/tools',
    label: t('tools'),
    icon: Wrench,
    testId: 'settings-hover-tools',
  },
  {
    to: '/settings/preferences',
    label: t('preferences'),
    icon: SlidersHorizontal,
    testId: 'settings-hover-preferences',
  },
  {
    to: '/settings/notification',
    label: t('notification'),
    icon: MessageSquare,
    testId: 'settings-hover-notification',
  },
] as const;

export const SettingsHoverContent: React.FC = () => {
  const { t } = useTranslation('pleri/chat');
  return (
    <div className="w-max max-w-[360px] min-w-[260px]">
      <div className="space-y-0.5">
        {settingsLinks(t).map((item) => {
          const Icon = item.icon;
          return (
            <Link
              key={item.to}
              to={item.to}
              className={LIST_ITEM_CLASS}
              data-testid={item.testId}
            >
              <span className={ICON_WRAPPER_CLASS}>
                <Icon className="h-4 w-4 stroke-[1.8]" />
              </span>
              <span className="min-w-0 flex-1 truncate font-medium text-gray-900 dark:text-gray-100">
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
      <div className="mt-3 flex justify-end border-t border-gray-100 pt-3 dark:border-gray-800">
        <Link
          to="/settings/preferences"
          className="inline-flex items-center gap-1.5 text-sm font-medium text-orange-600 transition-colors hover:text-orange-700"
          data-testid="settings-hover-open-all"
        >
          {t('openSettings')}
          <ArrowRight className="h-3.5 w-3.5" />
        </Link>
      </div>
    </div>
  );
};
